import React, { useEffect } from 'react'
import { useSnapshot } from 'valtio'
import { state } from '../../context/store'
import styled from 'styled-components'
import { PriceDisplay } from './index'
import { Text, Column, Grid, Dot, Row, IconWrap } from '../Blocks';
import {
  getRibModeDescription, getSealantModeDescription, getFoamDescription,
  getRaceNumberDescription, getSidesDescription, getSuperBadgeDescription, getSideLogoDescription
} from '../../utilities'
import { setPage, decrementPage, incrementPage } from '../../utilities'
import { useCameraAutoFocus } from '../../utilities/useCameraAutoFocus'
import { useFrame } from '@react-three/fiber'

import {
  AiOutlineFullscreen,
  AiOutlineArrowLeft,
  AiOutlineArrowRight,
} from 'react-icons/ai'


const NavigationControls = () => {
  const snap = useSnapshot(state.current)
  const page = snap.currentStep
  const pageCount = snap.steps.length

  const descriptions = {

    sidePanels: 'Side Color: ' + getSidesDescription(snap.choices.sidePanels.selected),
    // foam: 'Purchasing: ' + getFoamDescription(snap.choices.foam.selected.mode),
    topPanel: 'Top Color: ' + snap.choices.topPanel.selected.name,
    ribs: getRibModeDescription(snap.choices.ribs.selected.mode, snap.choices.ribs.selected.rib[0].name),
    superBadge: snap.choices.superBadge
      ? 'Badge: ' + getSuperBadgeDescription(snap.choices.superBadge.selected)
      : null,
    raceNumber: snap.choices.raceNumber
      ? 'Race Number: ' + getRaceNumberDescription(snap.choices.raceNumber.selected)
      : null,
    topLogo: 'Top Logo: ' + snap.choices.topLogo.selected.mode,
    sideLogo: 'Side Logos: ' + getSideLogoDescription(snap.choices.sideLogos.selected.name),
    sealant: 'Sealant: ' + getSealantModeDescription(snap.choices.sealant.selected),
    confirm: 'Confirm Choices?',
  }

  const Dots = () => {

    return (
      <Row id="navigation-dots-component" justify="center" gap="min(2.25vw, 20px)"     >
        {snap.steps.map((page, index) => (
          <Dot
            key={page + index}
            current={snap.currentStep === index}
            handleClick={() => setPage(index)}
            name={index}
          />
        ))}
      </Row>
    )
  }

  const BackArrow = () => {
    return (
      <IconWrap
        handleClick={() => {
          decrementPage(page)
        }}
        message="Prev Step"
        // off={(snap.optionPage <= 0).toString()}
        off={snap.currentStep <= 0 || snap.modal.open}
      >
        <AiOutlineArrowLeft />
      </IconWrap>
    )
  }
  const NextArrow = () => {
    return (
      <IconWrap
        handleClick={() => {
          incrementPage(page)
        }}
        message="Next Step"
        off={snap.currentStep + 1 === pageCount || snap.modal.open}
      >
        <AiOutlineArrowRight />
      </IconWrap>
    )
  }

  return (

    <Grid id="navigation-component" mar="0 auto" cols="75px 1fr 75px" width="100%" maxWidth="min(800px, 100vw)" justify="space-between" gap="0">
      <BackArrow />
      <Column gap="8px" justify="center" width="100%" id="steps-navigation-component"  >

        <Text size="16px">{descriptions[state.current.steps[page].link]} <PriceDisplay /></Text>
        <Dots />
      </Column>


      <NextArrow />
    </Grid>

  )
}

export default NavigationControls




